import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip
} from '@mui/material';

import { Box, Modal, Button, IconButton, Chip } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';


import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
import "../../../styles/Auth/coupon.css";
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";

const DetailItem = ({ label, value, fullWidth, icon, color = "#3C0008" }) => (
    <Box sx={{
        gridColumn: fullWidth ? 'span 2' : 'span 1',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 1.8,
        borderRadius: '16px',
        bgcolor: '#ffffff',
        border: '1px solid #f1f5f9',
        transition: 'all 0.2s ease',
        '&:hover': {
            borderColor: `${color}40`,
            boxShadow: `0 4px 12px ${color}08`,
            transform: 'translateY(-2px)'
        }
    }}>
        <Box sx={{
            color: color,
            display: 'flex',
            p: 1.2,
            borderRadius: '12px',
            bgcolor: `${color}10`,
            border: `1px solid ${color}15`
        }}>
            {icon && <Icon icon={icon} style={{ fontSize: '20px' }} />}
        </Box>
        <Box sx={{ flex: 1 }}>
            <Typography
                variant="caption"
                sx={{
                    color: '#94a3b8',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontSize: '9px',
                    display: 'block',
                    mb: 0.2
                }}
            >
                {label}
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: '#1e293b',
                    fontWeight: 700,
                    fontSize: '13.5px',
                    lineHeight: 1.2
                }}
            >
                {value || "-"}
            </Typography>
        </Box>
    </Box>
);

const SectionHeader = ({ icon, title, color = "#3C0008" }) => (
    <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 2.5,
        mt: 1,
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            left: 0,
            width: '40px',
            height: '3px',
            borderRadius: '2px',
            bgcolor: color
        }
    }}>
        <Box sx={{
            display: 'flex',
            p: 1,
            borderRadius: '10px',
            bgcolor: color,
            color: '#ffffff',
            boxShadow: `0 8px 16px ${color}30`
        }}>
            <Icon icon={icon} style={{ fontSize: '18px' }} />
        </Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            {title}
        </Typography>
    </Box>
);
const OfferPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const isAddCoupon = location.pathname === '/coupons/add';
    const [searchQuery, setSearchQuery] = useState('');
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [stores, setStores] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const sessionToken = localStorage.getItem("Token");
    const [couponsToDelete, setCouponsToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [loading, setLoading] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCouponId, setEditCouponId] = useState(null);
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isViewOfferPopup, setIsViewOfferPopup] = useState(false);
    const [viewOfferData, setViewOfferData] = useState(null);
    const sort = [[sortField, sortOrder]];
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [isAddStore, setIsAddStore] = useState(false);
    const [LoaderText, setLoaderText] = useState('');
    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        storeName: "", // Initialize storeName
        couponCode: "",
        couponType: [],

        discountType: "",
        percentageOrAmount: "",

        useLimit: "",
        startTime: null,
        endTime: null,
        minimumPurchaseAmount: "",
        daysAppliedon: []
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            // Handle single storeId
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId, formData.storeName]);





    const days = [
        { key: "Sunday", label: "S" },
        { key: "Monday", label: "M" },
        { key: "Tuesday", label: "T" },
        { key: "Wednesday", label: "W" },
        { key: "Thursday", label: "T" },
        { key: "Friday", label: "F" },
        { key: "Saturday", label: "S" },
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Coupon Code',
        'Start On',
        'Expire On',
        'Amount Or Percentage',
        'Status',
        'Action',
    ];
    const handleOpen = (couponId) => {
        setCouponsToDelete(couponId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCouponsToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleViewOffer = async (offerId) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(`coupons/coupon/${offerId}`, {}, token);
            if (res?.data) {
                let couponData = res.data;
                const sId = couponData.storeId?._id || couponData.storeId || "";
                let sName = couponData.storeId?.storeName || "";

                if (sId && !sName) {
                    try {
                        const storeRes = await getData(`stores/store/${sId}`, {}, token);
                        if (storeRes?.data) {
                            sName = storeRes.data.storeName;
                            if (typeof couponData.storeId === 'object' && couponData.storeId !== null) {
                                couponData.storeId.storeName = sName;
                            } else {
                                couponData.storeId = { _id: sId, storeName: sName };
                            }
                        }
                    } catch (err) {
                        console.error("Failed to fetch store details for view", err);
                    }
                }
                setViewOfferData(couponData);
                setIsViewOfferPopup(true);
            }
        } catch (error) {
            console.error("View Offer Error:", error);
            toast.error("Failed to load coupon details");
        }
    };

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    const handleAddCoupon = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            const couponData = {
                storeId: formData.storeId,
                couponCode: formData.couponCode.trim(),
                couponType: formData.couponType, // ["product","service"]

                discountType: formData.discountType, // percentage | fixed
                percentageOrAmount: Number(formData.percentageOrAmount),

                startTime: formData.startTime,
                endTime: formData.endTime,
                useLimit: Number(formData.useLimit),
                minimumPurchaseAmount: Number(formData.minimumPurchaseAmount),
                daysAppliedon: formData.daysAppliedon
            };

            console.log("Sending coupon data:", couponData);

            const response = await postData("coupons/", couponData, token);

            toast.success(response.message || "Coupon added successfully");

            // Reset form
            setFormData({
                storeId: "",
                couponCode: "",
                couponType: [],
                discountType: "",
                percentageOrAmount: "",
                useLimit: "",
                startTime: null,
                endTime: null,
                minimumPurchaseAmount: "",
                daysAppliedon: []
            });

            navigate("/coupons");
            fetchCoupon(currentPage, limit, searchQuery);

        } catch (error) {
            console.error("Add Coupon Error:", error);
            toast.error(error.message || "Add Coupon Failed");
        } finally {
            setTimeout(() => setShowLoader(false), 1500);
        }
    };




    useEffect(() => {
        fetchCoupon(currentPage, limit, searchQuery);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);


    const fetchCoupon = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            couponCode: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };

        const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;

        if (sid && sid.length === 24) {
            params.storeId = sid;
        }

        try {
            setLoading(true);

            const response = await getData(
                "coupons/coupons",
                params,
                sessionToken // ✅ use token properly
            );

            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch Coupons");
                return;
            }

            const resultsWrapper = response?.data;
            const couponsList = resultsWrapper?.results || [];
            const totalCount = resultsWrapper?.totalItems || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setCoupons(couponsList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Coupons");
        } finally {
            setLoading(false);
        }
    };


    const handleUpdateCoupon = async (e) => {
        e.preventDefault();

        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            const updatedCouponData = {
                storeId: formData.storeId,
                couponCode: formData.couponCode.trim(),
                couponType: formData.couponType,

                discountType: formData.discountType,
                percentageOrAmount: Number(formData.percentageOrAmount),

                startTime: formData.startTime,
                endTime: formData.endTime,
                useLimit: Number(formData.useLimit),
                minimumPurchaseAmount: Number(formData.minimumPurchaseAmount),
                daysAppliedon: formData.daysAppliedon
            };

            console.log("Updating Coupon with data:", updatedCouponData);

            const response = await putData(
                `coupons/coupon/${editCouponId}`,
                updatedCouponData,
                token
            );

            toast.success(response.message || "Coupon updated successfully");

            // ✅ Close popup & refresh
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchCoupon(currentPage, limit);
            triggerRefresh();

        } catch (error) {
            console.error(error);
            toast.error(error.message || "Error updating coupon");
        } finally {
            setTimeout(() => setShowLoader(false), 1500);
        }
    };



    const handleDeleteCoupon = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`coupons/coupon/${couponsToDelete}`, token);
            toast.success(response.message || "Coupon deleted successfully");
            setCouponsToDelete(null);
            fetchCoupon(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Coupon");
        }
    }

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const validateFields = (data) => {
        let newErrors = {};

        if (!data.storeId) {
            newErrors.storeId = "Store is required";
        }

        if (!data.couponCode) {
            newErrors.couponCode = "Coupon Code is required";
        }

        if (!Array.isArray(data.couponType) || data.couponType.length === 0) {
            newErrors.couponType = "Select at least one coupon type";
        }

        if (!data.discountType) {
            newErrors.discountType = "Discount type is required";
        }

        if (
            data.percentageOrAmount === "" ||
            data.percentageOrAmount === null ||
            Number(data.percentageOrAmount) <= 0
        ) {
            newErrors.percentageOrAmount = "Enter a valid discount value";
        }

        // Optional but recommended
        if (
            data.discountType === "percentage" &&
            Number(data.percentageOrAmount) > 100
        ) {
            newErrors.percentageOrAmount = "Percentage cannot exceed 100";
        }

        if (!data.useLimit) {
            newErrors.useLimit = "Use limit is required";
        }

        if (!data.startTime) {
            newErrors.startTime = "Start date is required";
        }

        if (!data.endTime) {
            newErrors.endTime = "End date is required";
        }

        if (new Date(data.endTime) < new Date(data.startTime)) {
            newErrors.endTime = "End date must be after start date";
        }

        if (!data.minimumPurchaseAmount) {
            newErrors.minimumPurchaseAmount = "Minimum purchase amount is required";
        }

        if (!Array.isArray(data.daysAppliedon) || data.daysAppliedon.length === 0) {
            newErrors.daysAppliedon = "Select at least one day";
        }

        return newErrors;
    };

    const handleDateChangeWithYearCheck = (fieldName, value) => {
        if (!value) {
            setFormData(prev => ({ ...prev, [fieldName]: null }));
            return;
        }

        // YYYY-MM-DD
        const year = value.split("-")[0];

        if (year.length > 4) {
            toast.error("Year should contain only 4 digits");
            return;
        }

        setFormData(prev => ({
            ...prev,
            [fieldName]: new Date(value)
        }));
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-zloader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <div className="product-main">
                    {isAddCoupon ? (
                        <div className="add-coupon-form">
                            <Typography variant="h6" mb={2}>
                                Add Coupon
                            </Typography>
                            <form className="coupon-form">
                                <div className="Coupon-form-row">

                                    {/* ===== STORE ===== */}
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Store Name</label>
                                        <StoreMultiSelect
                                            value={formData.storeId ? [{ value: formData.storeId, label: formData.storeName || stores.find(s => s._id === formData.storeId)?.storeName || "Selected Store" }] : []}
                                            onChange={(val) => {
                                                const storeId = val && val.length > 0 ? val[0].value : "";
                                                const storeName = val && val.length > 0 ? val[0].label : "";
                                                setFormData(prev => ({ ...prev, storeId, storeName }));
                                                setSelectedStoreId(storeId);
                                                window.dispatchEvent(new Event("storeChanged"));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            onAddStore={() => setIsAddStore(true)}
                                            isMulti={false}
                                        />
                                    </div>

                                    {/* ===== COUPON CODE ===== */}
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Coupon Code</label>
                                        <input
                                            type="text"
                                            className="Coupon-input"
                                            placeholder="Enter coupon code"
                                            value={formData.couponCode}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, couponCode: e.target.value }))
                                            }
                                        />
                                        {errors.couponCode && <p className="field-error">{errors.couponCode}</p>}
                                    </div>



                                    {/* ===== USE LIMIT ===== */}
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Use Limit</label>
                                        <input
                                            type="number"
                                            className="Coupon-input"
                                            placeholder="Enter use limit"
                                            value={formData.useLimit}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, useLimit: e.target.value }))
                                            }
                                        />
                                        {errors.useLimit && <p className="field-error">{errors.useLimit}</p>}
                                    </div>

                                    {/* ===== COUPON TYPE CHECKBOX ===== */}
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Coupon Type</label>

                                        <div className="coupon-type-checkbox">
                                            {["product", "service"].map(type => (
                                                <label key={type} className="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={formData.couponType.includes(type)}
                                                        onChange={() =>
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                couponType: prev.couponType.includes(type)
                                                                    ? prev.couponType.filter(t => t !== type)
                                                                    : [...prev.couponType, type]
                                                            }))
                                                        }
                                                    />
                                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                                </label>
                                            ))}
                                        </div>

                                        {errors.couponType && <p className="field-error">{errors.couponType}</p>}
                                    </div>
                                </div>

                                {/* ===== DISCOUNT ===== */}
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Discount Type</label>
                                        <select
                                            className="Coupon-input"
                                            value={formData.discountType}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, discountType: e.target.value }))
                                            }
                                        >
                                            <option value="">Select</option>
                                            <option value="percentage">Percentage</option>
                                            <option value="fixed">Fixed</option>
                                        </select>
                                    </div>

                                    <div className="Coupon-form-group">
                                        <label className="input-label">
                                            {formData.discountType === "percentage" ? "Percentage (%)" : "Amount (₹)"}
                                        </label>
                                        <input
                                            type="number"
                                            className="Coupon-input"
                                            value={formData.percentageOrAmount}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, percentageOrAmount: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>


                                {/* ===== DATES ===== */}
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="Coupon-input"
                                            value={formData.startTime ? new Date(formData.startTime).toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                handleDateChangeWithYearCheck("startTime", e.target.value)
                                            }
                                        />

                                    </div>

                                    <div className="Coupon-form-group">
                                        <label className="input-label">End Date</label>
                                        <input
                                            type="date"
                                            className="Coupon-input"
                                            value={formData.endTime ? new Date(formData.endTime).toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                handleDateChangeWithYearCheck("endTime", e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                {/* ===== MIN PURCHASE + DAYS ===== */}
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Minimum Purchase Amount</label>
                                        <input
                                            type="number"
                                            className="Coupon-input"
                                            value={formData.minimumPurchaseAmount}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, minimumPurchaseAmount: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="Coupon-form-group">
                                        <label className="input-label">Days Applied On</label>
                                        <div className="days-container">
                                            {days.map(day => (
                                                <button
                                                    key={day.key}
                                                    type="button"
                                                    className={`day-btn ${formData.daysAppliedon.includes(day.key) ? "active" : ""}`}
                                                    onClick={() =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            daysAppliedon: prev.daysAppliedon.includes(day.key)
                                                                ? prev.daysAppliedon.filter(d => d !== day.key)
                                                                : [...prev.daysAppliedon, day.key]
                                                        }))
                                                    }
                                                >
                                                    {day.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>


                                {/* ===== BUTTONS ===== */}
                                <div className="Coupon-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleAddCoupon}>
                                        Add Coupon
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/coupons')}>
                                        Cancel
                                    </button>
                                </div>
                            </form>

                        </div>
                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 2 }}>Coupons</Typography>
                            <div className="product-widgets">
                                <div className="search-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search coupons..."
                                        className="coupon-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <Icon icon="mdi:magnify" className="search-icon" />
                                </div>
                                {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                    <StoreSingleAllStoresSelect
                                        value={store}
                                        onChange={
                                            (store) => {
                                                setStore(store)
                                            }
                                        }
                                    />
                                )}
                                <button className="add-Product-button" onClick={() => navigate('/coupons/add')}>+ Add Coupon</button>
                            </div>
                            <Box component={Paper}>
                                <TableContainer component={Paper} sx={{
                                    maxHeight: 400,
                                    overflowY: "auto",
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}>
                                    <Table className="custom-product-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isCoupon = heading === "Coupon Code";
                                                    const isAmount = heading === "Amount Or Percentage";

                                                    const sortKey = isCoupon
                                                        ? "couponCode"
                                                        : isAmount
                                                            ? "percentageOrAmount"
                                                            : null;

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 10,
                                                                backgroundColor: "#3C0008",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>

                                        </TableHead>
                                        <TableBody>
                                            {coupons.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={headings.length}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No coupons found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                coupons.map((coupon, index) => (
                                                    <TableRow key={coupon._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{coupon.couponCode}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}> {coupon.startTime
                                                            ? new Date(coupon.startTime).toISOString().split("T")[0]
                                                            : ""}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{coupon.endTime
                                                            ? new Date(coupon.endTime).toISOString().split("T")[0]
                                                            : ""}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{coupon.discountType === "percentage"
                                                            ? `${coupon.percentageOrAmount}%`
                                                            : `₹${coupon.percentageOrAmount}`}</Typography></TableCell>

                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: coupon.isActive ? '#3C0008' : '#C10000',
                                                                    color: coupon.isActive ? '#fff' : '#fff',
                                                                    fontWeight: 500,
                                                                    padding: '4px 8px',
                                                                    borderRadius: '20px',
                                                                    width: '90px',
                                                                    maxHeight: '70px',
                                                                    fontSize: '12px',
                                                                    textTransform: 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: coupon.isActive ? '#3C0008' : '#C10000',
                                                                        boxShadow: 'none',
                                                                    },
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    margin: '0 auto',
                                                                    boxShadow: 'none',
                                                                }}
                                                            >
                                                                {coupon.isActive ? 'Active' : 'Inactive'}
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Coupon">
                                                                    <Icon
                                                                        icon={plusIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer", color: "#3C0008" }}
                                                                        onClick={() => handleViewOffer(coupon._id)}
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Coupon">
                                                                    <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                        const sId = coupon.storeId?._id || coupon.storeId || "";
                                                                        const sName = coupon.storeId?.storeName || stores.find(s => s._id === sId)?.storeName || "";

                                                                        setFormData({
                                                                            couponCode: coupon.couponCode || '',
                                                                            startTime: coupon.startTime ? new Date(coupon.startTime) : null,
                                                                            endTime: coupon.endTime ? new Date(coupon.endTime) : null,
                                                                            discountType: coupon.discountType || '',
                                                                            useLimit: coupon.useLimit || '',
                                                                            percentageOrAmount: coupon.percentageOrAmount || '',
                                                                            minimumPurchaseAmount: coupon.minimumPurchaseAmount || '',
                                                                            daysAppliedon: Array.isArray(coupon.daysAppliedon) ? coupon.daysAppliedon : [],
                                                                            couponType: Array.isArray(coupon.couponType) ? coupon.couponType : [],
                                                                            storeId: sId,
                                                                            storeName: sName
                                                                        });
                                                                        setEditCouponId(coupon._id);
                                                                        setIsPopupMode(true);
                                                                        setIsEditMode(true);
                                                                        setLoaderText("Updating Coupon...");
                                                                    }} />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && (
                                                                    <Tooltip title="Delete Coupon">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            onClick={() => handleOpen(coupon._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>

                                                        </TableCell>
                                                    </TableRow>

                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="product-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="product-section showing-range">
                                        {
                                            limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        >
                                            <Icon icon="mdi:chevron-double-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        >
                                            <Icon icon="mdi:chevron-left" />
                                        </button>

                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        >
                                            <Icon icon="mdi:chevron-right" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        >
                                            <Icon icon="mdi:chevron-double-right" />
                                        </button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setLoaderText("");
                                                setFormData({
                                                    couponCode: '',
                                                    percentageOrAmount: '',
                                                    discountType: '',
                                                    daysAppliedon: '',
                                                    startTime: '',
                                                    endTime: '',
                                                    minimumPurchaseAmount: '',
                                                    useLimit: ''
                                                });

                                            }}
                                        />
                                        <div className="popup-form">
                                            <Typography variant="h6" sx={{ mb: 4, textAlign: "center" }}>{isEditMode ? "Edit Coupon" : "Add Coupon"}</Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateCoupon}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="couponCode" className="input-label">
                                                            Coupon Code
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter coupon code"
                                                            className="Coupon-input"
                                                            value={formData.couponCode}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, couponCode: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <StoreMultiSelect
                                                            value={
                                                                formData.storeId
                                                                    ? [{
                                                                        value: formData.storeId,
                                                                        label: formData.storeName
                                                                    }]
                                                                    : []
                                                            }
                                                            onChange={(val) => {
                                                                // ❌ Prevent clearing if only one store
                                                                if (adminStoreIds.length === 1) return;

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: val?.[0]?.value || "",
                                                                    storeName: val?.[0]?.label || "",

                                                                }));
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="useLimit" className="input-label">
                                                            Use Limit
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter use limit"
                                                            className="Coupon-input"
                                                            value={formData.useLimit}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, useLimit: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {/* ===== COUPON TYPE ===== */}
                                                <div className="form-group">
                                                    <label className="input-label">Coupon Type</label>

                                                    <div className="coupon-type-checkbox">
                                                        {["product", "service"].map(type => (
                                                            <label key={type} className="checkbox-label">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={formData.couponType.includes(type)}
                                                                    onChange={() =>
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            couponType: prev.couponType.includes(type)
                                                                                ? prev.couponType.filter(t => t !== type)
                                                                                : [...prev.couponType, type]
                                                                        }))
                                                                    }
                                                                />
                                                                {type.charAt(0).toUpperCase() + type.slice(1)}
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="startTime" className="input-label">
                                                            Start Date
                                                        </label>

                                                        <input
                                                            type="date"
                                                            className="Coupon-input"
                                                            value={
                                                                formData.startTime
                                                                    ? new Date(formData.startTime).toISOString().slice(0, 10)
                                                                    : ""
                                                            }
                                                            onChange={(e) =>
                                                                handleDateChangeWithYearCheck("startTime", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="endTime" className="input-label">
                                                            End Date
                                                        </label>

                                                        <input
                                                            type="date"
                                                            className="Coupon-input"
                                                            value={
                                                                formData.endTime
                                                                    ? new Date(formData.endTime).toISOString().slice(0, 10)
                                                                    : ""
                                                            }
                                                            onChange={(e) =>
                                                                handleDateChangeWithYearCheck("endTime", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="discountType" className="input-label">
                                                            Discount Type
                                                        </label>
                                                        <select
                                                            id="discountType"
                                                            className="Coupon-input"
                                                            value={formData.discountType}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, discountType: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Discount Type</option>
                                                            <option value="percentage">Percentage</option>
                                                            <option value="fixed">Fixed</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="percentageOrAmount" className="input-label">
                                                            {formData.discountType === "percentage" ? "Percentage (%)" : "Amount (₹)"}
                                                        </label>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            placeholder={
                                                                formData.discountType === "percentage"
                                                                    ? "Enter discount percentage"
                                                                    : "Enter discount amount"
                                                            }
                                                            className="Coupon-input"
                                                            value={formData.percentageOrAmount}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, percentageOrAmount: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="minimumPurchaseAmount" className="input-label">
                                                            Minimum Purchase Amount
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter minimum purchase amount"
                                                            className="Coupon-input"
                                                            value={formData.minimumPurchaseAmount}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, minimumPurchaseAmount: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="percentageOrAmount" className="input-label">
                                                            Days Applied On
                                                        </label>
                                                        <div className="days-container">
                                                            {days.map((day) => (
                                                                <button
                                                                    type="button"
                                                                    className={`day-btn ${formData.daysAppliedon?.includes(day.key) ? "active" : ""}`}
                                                                    onClick={() => {
                                                                        setFormData(prev => {
                                                                            const appliedDays = prev.daysAppliedon || [];
                                                                            return appliedDays.includes(day.key)
                                                                                ? { ...prev, daysAppliedon: appliedDays.filter(d => d !== day.key) }
                                                                                : { ...prev, daysAppliedon: [...appliedDays, day.key] };
                                                                        });
                                                                    }}
                                                                >
                                                                    {day.label}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">
                                                        {isEditMode ? "Update Coupon" : "Add Coupon"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="cancel-Product-button"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this coupon?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteCoupon}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>

                            {isViewOfferPopup && viewOfferData && (
                                <Modal
                                    open={isViewOfferPopup}
                                    onClose={() => setIsViewOfferPopup(false)}
                                    closeAfterTransition
                                >
                                    <Box sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        width: { xs: '95%', sm: '85%', md: 850 },
                                        maxHeight: '90vh',
                                        bgcolor: '#ffffff',
                                        borderRadius: '32px',
                                        boxShadow: '0 30px 60px rgba(0,0,0,0.2)',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        outline: 'none',
                                        animation: 'modalSlideUp 0.5s cubic-bezier(0, 0, 0.2, 1)',
                                        '@keyframes modalSlideUp': {
                                            '0%': { transform: 'translate(-50%, -45%)', opacity: 0 },
                                            '100%': { transform: 'translate(-50%, -50%)', opacity: 1 }
                                        }
                                    }}>
                                        {/* Premium Header Banner */}
                                        <Box sx={{
                                            height: '180px',
                                            background: 'linear-gradient(135deg, #3C0008 0%, #3C0008 100%)',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            px: 5,
                                            overflow: 'hidden'
                                        }}>
                                            {/* Decorative Circles */}
                                            <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.1)', filter: 'blur(40px)' }} />
                                            <Box sx={{ position: 'absolute', bottom: -30, left: '20%', width: 100, height: 100, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', filter: 'blur(20px)' }} />

                                            <IconButton
                                                onClick={() => setIsViewOfferPopup(false)}
                                                sx={{ position: 'absolute', top: 20, right: 20, color: 'white', '&:hover': { background: 'rgba(255,255,255,0.2)', transform: 'rotate(90deg)' }, transition: 'all 0.3s ease' }}
                                            >
                                                <Icon icon="solar:close-circle-bold-duotone" fontSize={32} />
                                            </IconButton>

                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', zIndex: 1 }}>
                                                <Box sx={{ p: 2, borderRadius: '24px', background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.3)', display: 'flex' }}>
                                                    <Icon icon="solar:ticket-sale-bold-duotone" style={{ fontSize: '48px', color: '#fff' }} />
                                                </Box>
                                                <Box>
                                                    <Typography variant="h4" sx={{ color: 'white', fontWeight: 900, mb: 0.5, letterSpacing: '-0.5px' }}>
                                                        {viewOfferData.couponCode}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                        <Chip
                                                            label={viewOfferData.discountType === 'percentage' ? `${viewOfferData.percentageOrAmount}% OFF` : `₹${viewOfferData.percentageOrAmount} OFF`}
                                                            sx={{ bgcolor: '#ffffff', color: '#3C0008', fontWeight: 800, fontSize: '13px', height: '28px', border: 'none' }}
                                                        />
                                                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <Icon icon="solar:globus-outline" fontSize={16} />
                                                            {viewOfferData.couponType?.join(' + ')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Modal Content - Refined Layout */}
                                        <Box sx={{ p: 5, overflowY: 'auto', flex: 1, bgcolor: '#fcfcfd' }}>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' }, gap: 5 }}>

                                                {/* Left Column: Timing & Logic */}
                                                <Box>
                                                    <SectionHeader icon="solar:calendar-date-bold-duotone" title="Validity & Conditions" color="#3C0008" />
                                                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2.5 }}>
                                                        <DetailItem label="Start From" value={viewOfferData.startTime ? new Date(viewOfferData.startTime).toLocaleDateString("en-GB") : "-"} icon="solar:calendar-add-bold-duotone" color="#3C0008" />
                                                        <DetailItem label="Valid Until" value={viewOfferData.endTime ? new Date(viewOfferData.endTime).toLocaleDateString("en-GB") : "-"} icon="mdi:calendar-check" color={new Date(viewOfferData.endTime) < new Date() ? "#3C0008" : "#3C0008"} />
                                                        <DetailItem label="Remaining" value={viewOfferData.useLimit ? `${Math.max(0, viewOfferData.useLimit - (viewOfferData.usedCount || 0))} Times` : "Unlimited"} icon="solar:box-minimalistic-bold-duotone" color={(viewOfferData.useLimit > 0 && (viewOfferData.usedCount || 0) >= viewOfferData.useLimit) ? "#ef4444" : "#3C0008"} />
                                                        <DetailItem label="Requirement" value={`Min. ₹${viewOfferData.minimumPurchaseAmount}`} icon="solar:cart-large-minimalistic-bold-duotone" color="#3C0008" />
                                                    </Box>
                                                </Box>

                                                {/* Right Column: Active Store & Days */}
                                                <Box>
                                                    <SectionHeader icon="solar:shop-2-bold-duotone" title="Distribution & Access" color="#3C0008" />
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                                                        <DetailItem fullWidth label="Assigned Store" value={viewOfferData.storeId?.storeName || stores.find(s => s._id === (viewOfferData.storeId?._id || viewOfferData.storeId))?.storeName || "All Locations"} icon="solar:map-point-school-bold-duotone" color="#3C0008" />

                                                        <Box sx={{ p: 2.5, borderRadius: '20px', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                                                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800, textTransform: 'uppercase', fontSize: '9px', display: 'block', mb: 2 }}>
                                                                Active Days Schedule
                                                            </Typography>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                                                                {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => {
                                                                    const isActive = viewOfferData.daysAppliedon?.includes(day);
                                                                    return (
                                                                        <Box
                                                                            key={day}
                                                                            sx={{
                                                                                flex: 1,
                                                                                height: '40px',
                                                                                borderRadius: '12px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                bgcolor: isActive ? '#3C0008' : '#f8fafc',
                                                                                color: isActive ? '#fff' : '#94a3b8',
                                                                                border: isActive ? 'none' : '1px solid #f1f5f9',
                                                                                fontWeight: 800,
                                                                                fontSize: '11px',
                                                                                transition: 'all 0.2s ease'
                                                                            }}
                                                                        >
                                                                            {day.substring(0, 3)}
                                                                        </Box>
                                                                    );
                                                                })}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                            </Box>
                                        </Box>

                                        {/* Actions Footer - Glassy Effect */}
                                        <Box sx={{ px: 5, py: 3, borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', bgcolor: '#fcfcfd' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => setIsViewOfferPopup(false)}
                                                startIcon={<Icon icon="solar:check-circle-bold" />}
                                                sx={{
                                                    background: '#3C0008',
                                                    color: '#fff',
                                                    borderRadius: '16px',
                                                    px: 5,
                                                    height: '48px',
                                                    textTransform: 'none',
                                                    fontWeight: 700,
                                                    fontSize: '15px',
                                                    boxShadow: '0 10px 20px rgba(30,41,59,0.2)',
                                                    '&:hover': { background: '#0f172a', transform: 'translateY(-2px)', boxShadow: '0 12px 25px rgba(30,41,59,0.3)' },
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                Close
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Footer />
            {isAddStore && (
                <div className="popup-overlay">
                    <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                        <Icon
                            icon={closeIcon}
                            className="popup-close-icon-outside"
                            onClick={() => setIsAddStore(false)}
                        />
                        <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                            <AddStoreForm
                                onSuccess={() => {
                                    setIsAddStore(false);
                                    // Trigger store reload/refresh if needed
                                    // For now just close, user can re-search
                                }}
                                onCancel={() => setIsAddStore(false)}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default OfferPage;
